import { render, staticRenderFns } from "./GameLobby.vue?vue&type=template&id=328285f0"
import script from "./GameLobby.vue?vue&type=script&lang=js"
export * from "./GameLobby.vue?vue&type=script&lang=js"
import style0 from "./GameLobby.vue?vue&type=style&index=0&id=328285f0&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/viparabclub/releases/20251208210823/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('328285f0')) {
      api.createRecord('328285f0', component.options)
    } else {
      api.reload('328285f0', component.options)
    }
    module.hot.accept("./GameLobby.vue?vue&type=template&id=328285f0", function () {
      api.rerender('328285f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/GameLobby.vue"
export default component.exports